import { PageOptions } from './../../../../../shared/data-table/data-table.interface';
import { BaseHttpService } from './../../../../../shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../../../../../config/config';
import { getEnv } from '../../../../../../modules/utility';

@Injectable()
export class TprReasonsApiService {

    constructor(private readonly http: BaseHttpService) { }

    public getTprReasons(tprToolId, pageOptions?: PageOptions) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/reasons?`
            + `page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}&tprToolId=${tprToolId}`;
        return this.http.get(url);
    }

    public getTprReasonCodes() {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/criteria/reason-code`;
        return this.http.get(url);
    }

    public createTprReason(params) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/reasons`;
        return this.http.post(url, params);
    }

    public updateTprReason(params) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/reasons`;
        return this.http.put(url, params);
    }

    public deleteTprReason(id) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/reasons/${id}`;
        return this.http.delete(url);
    }
}
